import { render } from "./InterconsultaAtencion.vue?vue&type=template&id=0d67493e&scoped=true"
import script from "./InterconsultaAtencion.vue?vue&type=script&lang=js"
export * from "./InterconsultaAtencion.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=0d67493e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d67493e"]])

export default __exports__